// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ProjectLineItem } from '@/project/api/types';

interface LineItemGroup {
  groupKey: string;
  items: ProjectLineItem[];
}

/**
 * Groups line items by their aggregation key and sorts items within each
 * group by start date. Groups are ordered by the earliest start date of their
 * first item.
 */
export function groupLineItems(lineItems: ProjectLineItem[]): LineItemGroup[] {
  const groupMap = new Map<string, ProjectLineItem[]>();

  for (const item of lineItems) {
    const key = item.aggregationKey;
    const existing = groupMap.get(key);
    if (existing) {
      existing.push(item);
    } else {
      groupMap.set(key, [item]);
    }
  }

  const groups: LineItemGroup[] = [];
  for (const [groupKey, items] of groupMap) {
    items.sort((a, b) => {
      const aTime = a.startOn ? a.startOn.toMillis() : Infinity;
      const bTime = b.startOn ? b.startOn.toMillis() : Infinity;
      return aTime - bTime;
    });
    groups.push({ groupKey, items });
  }

  return groups;
}

const GROUP_COLORS = [
  '#063DCB',
  '#14B8A6',
  '#828DF8',
  '#7B61FF',
  '#2ECDA7',
] as const;

/**
 * Returns a color for a group by its ordered index. Groups are assigned
 * colors in the order they appear, cycling through the palette.
 */
export function getGroupColor(groupIndex: number): string {
  return GROUP_COLORS[groupIndex % GROUP_COLORS.length];
}
